import { defaultHttpClient } from '../../httpClient';
import type { MarketParent } from './types';

/**
 * 부모 마켓 조회 API
 * 같은 업체가 셀러스, 메이커스 등 두 개 이상의 마켓을 같이 운영할 때 부모 마켓을 조회하는 용도
 */
export const getMarketParent = (marketId: number) => {
  return defaultHttpClient
    .request<MarketParent>({
      method: 'GET',
      url: `/api/v2/markets/${marketId}/parent`,
    })
    .then(result => result.data);
};
